/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslationStore } from '@/stores';
import { InputHTMLAttributes } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { EpDatepicker } from '../../../EpDatepicker';

interface IEpFormDatepickerProps extends InputHTMLAttributes<HTMLInputElement> {
  datepickerId: string;
  datepickerName: string;
  datepickerRequired?: boolean;
  // datepickerDisabled?: boolean
  // eslint-disable-next-line @typescript-eslint/ban-types
  datepickerOnChangeFunc?: (arg?: any) => void;
  isInlineDatepicker: boolean;
  cultureCode: string;
  errorMessage?: string;
  inputHasIcon?: boolean;
  inputIconName?: 'RegularCalendarAlt';
  inputIsFullWidth?: boolean;
  isoFormatDate?: boolean;
}

export const EpFormDatepicker = ({
  datepickerId,
  datepickerName,
  datepickerRequired = false,
  // datepickerDisabled = false,
  datepickerOnChangeFunc,
  isInlineDatepicker,
  cultureCode,
  errorMessage = '* Required Fied',
  inputHasIcon,
  inputIconName = 'RegularCalendarAlt',
  inputIsFullWidth,
  isoFormatDate = false,
}: IEpFormDatepickerProps) => {
  const { control, getValues } = useFormContext();
  const { translations } = useTranslationStore();

  return (
    <Controller
      name={datepickerName}
      control={control}
      rules={{
        required: {
          value: datepickerRequired,
          message: t(translations['gloabal'], errorMessage),
        },
      }}
      render={({ field }) => (
        <EpDatepicker
          datepickerId={datepickerId}
          cultureCode={cultureCode}
          datepickerOnChangeFunc={datepickerOnChangeFunc}
          datepickerInputName={field.name}
          reactHookFormValue={field.value}
          reactHookFormOnChangeFunc={field.onChange}
          reactHookFormGetValues={getValues}
          isInlineDatepicker={isInlineDatepicker}
          inputHasIcon={inputHasIcon}
          inputIconName={inputIconName}
          inputIsFullWidth={inputIsFullWidth}
          isoFormatDate={isoFormatDate}
        />
      )}
    />
  );
};
